import script from "./TermCondition.vue?vue&type=script&setup=true&lang=js"
export * from "./TermCondition.vue?vue&type=script&setup=true&lang=js"

import "./TermCondition.vue?vue&type=style&index=0&id=4157646e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4157646e"]])

export default __exports__